import { Spinner } from "react-bootstrap";

export const BootstrapSpinner = (props: {
  title?: string;
  inline?: boolean;
}) => {
  return (
      <div style={{ textAlign: "center" }}>
        <Spinner animation="border" />
        {!props.inline && <br />}
        {props.title || "Laster..."}
      </div>
  );
};
